import { useGoogleLogin } from '@react-oauth/google';
import { Button } from '@components/core';
import { connect } from "react-redux";
import { authTypes } from '@utils/constants/authTypes';
import { signIn } from "@actions/auth-actions";

function GoogleCustomButton({
  // eslint-disable-next-line no-shadow
  signIn, authSuccess, authError,
}) {
  async function onGoogleResponse(googleResponse) {
    try {
      const res = await signIn({ google_response: googleResponse });
      authSuccess(res.user, authTypes.google);
    } catch (err) {
      authError(err, authTypes.google);
    }
  }

  const loginWithGoogle = useGoogleLogin({
    onSuccess: (codeResponse) => onGoogleResponse(codeResponse),
    flow: 'implicit',
  });

  return (
    <Button
      variant="outline-dark"
      fullWidth
      leftIconName="google-logo"
      onClick={() => loginWithGoogle()}
      className="py-0"
    />
  );
}

export default connect(null, { signIn })(GoogleCustomButton);
